import React, { useState } from 'react';
import star from '../styles/img/star.svg';
import staractive from '../styles/img/staractive.svg';

const Star = ({ selected, onClick, starClassName }) => (
  <span onClick={onClick} style={{ cursor: 'pointer' }}>
    {selected ? (
      <img
        src={staractive}
        alt="star"
        className={`star_active ${starClassName ? starClassName : 'w-14 m-2'}`}
      />
    ) : (
      <img
        src={star}
        alt="star"
        className={`star_unactive ${starClassName ? starClassName : 'w-14 m-2'}`}
      />
    )}
  </span>
);

const Ratingstar = ({ starClassName, action }) => {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);

  const handleStarClick = (selectedRating) => {
    setRating(selectedRating);
    if (action) {
      action(selectedRating);
    }
  };

  const handleStarHover = (hoveredRating) => {
    setHoveredRating(hoveredRating);
  };

  const handleMouseLeave = () => {
    setHoveredRating(0);
  };

  const stars = Array.from({ length: 5 }, (_, index) => (
    <Star
      key={index}
      selected={index < (hoveredRating || rating)}
      onClick={() => handleStarClick(index + 1)}
      onMouseEnter={() => handleStarHover(index + 1)}
      starClassName={starClassName}
    />
  ));

  return (
    <div className=" text-5xl flex items-center justify-center">
      <div
        onMouseLeave={handleMouseLeave}
        style={{ display: 'flex', flexDirection: 'row' }}
      >
        {stars}
      </div>
      {/* <p>{rating} étoile(s) sélectionnée(s)</p> */}
    </div>
  );
};

export default Ratingstar;
